import React, { useState } from 'react';
import { YearPickerInput } from './YearPickerInput';
import { YearPickerModal } from './YearPickerModal';

export function YearPickerField({
  label,
  isRequired = true,
  value,
  onSelect,
  onClear,
  error = false,
  errorMessage = "",
  placeholder = "--Select Year--",
  disabled = false
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <YearPickerInput
        label={label}
        isRequired={isRequired}
        value={value}
        placeholder={placeholder}
        error={error}
        errorMessage={errorMessage}
        hasSelection={!!value}
        onSelectClick={() => !disabled && setIsModalOpen(true)}
        onClearClick={onClear}
        disabled={disabled}
      />

      <YearPickerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={(year) => {
          onSelect(year);
          setIsModalOpen(false);
        }}
        selectedValue={value}
      />
    </>
  );
}